export const theme = {
    breakpoint: 820,
    sidebar_width: 200,
}